module.exports = __webpack_public_path__ + "static/media/layout3-vid.550e1c90.svg";